import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTenantContext } from "../../../../context/Tenant/TenantContext";
import DataCutterDataSets from "./DataCutterDataSets";
import InrixDataSets from "./InrixDataSets";

const DataSets = () => {
  const { boundary } = useParams();
  const [boundaryName, setBoundaryName] = useState<string | undefined>();

  useEffect(() => {
    if (!boundary) return;
    setBoundaryName(decodeURIComponent(boundary));
  }, [boundary]);

  const config = useTenantContext().config;

  return (
    <div className="bg-light text-black p-3 flex-grow-1">
      {boundaryName && (
        <h1>
          {config.name === "Inrix" ? "Inrix" : "DataCutter"} Datasets for{" "}
          {boundaryName}
        </h1>
      )}
      {!boundaryName && (
        <h1>{config.name === "Inrix" ? "Inrix" : "DataCutter"} Datasets</h1>
      )}

      {config.name === "Inrix" ?
        <InrixDataSets boundary={boundaryName} />
      : <DataCutterDataSets boundary={boundaryName} />}
    </div>
  );
};

export default DataSets;
